export const professions = [
  "Registered Nurse",
  "Registered Practical Nurse",
  "Licensed Practical Nurse",
  "Nurse Practitioner",
  "Registered Psychiatric Nurse",

  "Physician",
  "Pharmacist",
  "Dentist",
  "Respiratory Therapist",
  "Medical Laboratory Technologist",
  "Medical Radiation Technologist",
  "Occupational Therapist",
  "Physiotherapist",
  "Speech Language Pathologist",
  "Social Worker",
  "Dietitian",
  "Paramedic",
];